import CalcManager from './lib/calc-manager';
import Tooltips from './lib/tooltips';

class App {
    constructor() {
        this.dom = {
            $: window.$,
            $window: $(window),
            $calc: $('.calc')
        };

        if (this.dom.$calc.length) {
            this.init();
        }
    }

    init() {
        //For Multiproduct only auto load first tab calculator
        if (this.dom.$calc.eq(0).find('.calc-form-tab:not(.active)').length > 0) {
            new CalcManager(this.dom.$calc.eq(0));
            this.dom.$calc.eq(0).find('.calc-form-tab:not(.active)').on('click', (e) => {
                $(e.currentTarget).off('click');
                this.dom.$calc.filter(':not(:eq(0))').each((calcId, calcObj) => new CalcManager(calcObj));
            });

        } else {
            this.dom.$calc.each((calcId, calcObj) => new CalcManager(calcObj));
        }
        new Tooltips();
    }
}

document.addEventListener('DOMContentLoaded', () => new App());